// Main JS for navrangdrapes
console.log('navrangdrapes JS initialized');

window.addToCart = function (event) {
    event.preventDefault();

    // Find the button more robustly
    const target = event.target;
    let button = target.closest('button') || target.querySelector('button[type="submit"]');

    const form = target.closest('form') || document.querySelector('form[action*="/cart/add"]');
    if (!form) return;

    // Ensure hidden id input reflects current variant selection
    const alpineContainer = document.querySelector('[x-data*="productPage"]');
    if (alpineContainer && window.Alpine) {
        const alpineData = Alpine.$data(alpineContainer);
        if (alpineData && alpineData.selectedVariantId) {
            const idInput = form.querySelector('input[name="id"]');
            if (idInput) idInput.value = alpineData.selectedVariantId;
        }
    }

    const formData = new FormData(form);

    if (button) {
        button.classList.add('is-loading');
        button.disabled = true;
    }

    fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        body: formData
    })
        .then(response => {
            if (!response.ok) throw new Error('Network response was not ok');
            return response.json();
        })
        .then(item => {
            // Refresh drawer content using Section Rendering API
            return fetch(window.location.pathname + '?sections=cart-drawer')
                .then(response => response.json())
                .then(section => {
                    const html = new DOMParser().parseFromString(section['cart-drawer'], 'text/html');
                    const drawerContent = document.getElementById('CartDrawerContent');
                    const newDrawerContent = html.getElementById('CartDrawerContent');

                    if (drawerContent && newDrawerContent) {
                        drawerContent.innerHTML = newDrawerContent.innerHTML;
                    }

                    // Refresh Razorpay Magic Checkout for AJAX content
                    if (typeof RazorpayMagicCheckout !== 'undefined' && RazorpayMagicCheckout.refresh) {
                        RazorpayMagicCheckout.refresh();
                    }

                    // Update header count
                    return fetch(window.Shopify.routes.root + 'cart.js')
                        .then(res => res.json())
                        .then(cart => {
                            const count = document.querySelector('[data-cart-count]');
                            if (count) count.textContent = cart.item_count;

                            // Open the drawer
                            if (window.Alpine) {
                                const body = document.querySelector('body');
                                const alpineData = Alpine.$data(body);
                                if (alpineData) {
                                    alpineData.cartOpen = true;
                                }
                            }
                        });
                });
        })
        .catch(error => {
            console.error('Error adding to cart:', error);
            alert('Could not add item to cart. Please try again.');
        })
        .finally(() => {
            if (button) {
                button.classList.remove('is-loading');
                button.disabled = false;
            }
        });
};

window.buyNow = function (event) {
    event.preventDefault();

    const target = event.target;
    const button = target.closest('button');
    const form = target.closest('form') || document.querySelector('form[action*="/cart/add"]');
    if (!form) return;

    // Ensure hidden id input reflects current variant selection
    const alpineContainer = document.querySelector('[x-data*="productPage"]');
    if (alpineContainer && window.Alpine) {
        const alpineData = Alpine.$data(alpineContainer);
        if (alpineData && alpineData.selectedVariantId) {
            const idInput = form.querySelector('input[name="id"]');
            if (idInput) idInput.value = alpineData.selectedVariantId;
        }
    }

    const formData = new FormData(form);

    if (button) {
        button.classList.add('is-loading');
        button.disabled = true;
    }

    // Clear cart first so only this product goes to checkout
    fetch(window.Shopify.routes.root + 'cart/clear.js', { method: 'POST' })
        .then(() => fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            body: formData
        }))
        .then(response => {
            if (!response.ok) throw new Error('Network response was not ok');
            return response.json();
        })
        .then(() => {
            window.location.href = '/checkout';
        })
        .catch(error => {
            console.error('Error during buy now:', error);
            alert('Could not process. Please try again.');
            if (button) {
                button.classList.remove('is-loading');
                button.disabled = false;
            }
        });
};

let cartDebounceTimer = null;
const CART_DEBOUNCE_MS = 500;

window.updateCart = function (line, quantity) {
    console.log('Updating cart: Line', line, 'Quantity', quantity);
    const drawer = document.getElementById('CartDrawerContent');
    if (!drawer) return;

    // 1. Instant Optimistic Update
    const itemContainers = drawer.querySelectorAll('[data-cart-item]');
    const targetItem = Array.from(itemContainers).find(item => item.getAttribute('data-cart-item') === line.toString());

    if (targetItem) {
        const qtyDisplay = targetItem.querySelector('span.w-8');
        if (qtyDisplay) {
            qtyDisplay.textContent = Math.max(0, quantity);
        }

        // If removing, dim it immediately
        if (quantity === 0) {
            targetItem.style.opacity = '0.3';
            targetItem.style.pointerEvents = 'none';
        }
    }

    // 2. Clear existing timer to reset the debounce window
    if (cartDebounceTimer) clearTimeout(cartDebounceTimer);

    // 3. Set new timer for backend sync
    cartDebounceTimer = setTimeout(() => {
        drawer.classList.add('cart-drawer-updating');

        const body = JSON.stringify({
            line: line,
            quantity: quantity,
            sections: 'cart-drawer'
        });

        fetch(window.Shopify.routes.root + 'cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body
        })
            .then(response => response.json())
            .then(state => {
                return fetch(window.location.pathname + '?sections=cart-drawer')
                    .then(response => response.json())
                    .then(section => {
                        const html = new DOMParser().parseFromString(section['cart-drawer'], 'text/html');
                        const newContent = html.getElementById('CartDrawerContent');
                        const currentDrawer = document.getElementById('CartDrawerContent');

                        if (newContent && currentDrawer) {
                            currentDrawer.innerHTML = newContent.innerHTML;
                        }

                        // Refresh Razorpay Magic Checkout for AJAX content
                        if (typeof RazorpayMagicCheckout !== 'undefined' && RazorpayMagicCheckout.refresh) {
                            RazorpayMagicCheckout.refresh();
                        }

                        const count = document.querySelector('[data-cart-count]');
                        if (count) count.textContent = state.item_count;
                    });
            })
            .catch(error => {
                console.error('Error updating cart:', error);
                window.location.reload();
            })
            .finally(() => {
                const refreshedDrawer = document.getElementById('CartDrawerContent');
                if (refreshedDrawer) {
                    refreshedDrawer.classList.remove('cart-drawer-updating');
                }
            });
    }, CART_DEBOUNCE_MS);
};

// Collection Filters & Search Logic
document.addEventListener('alpine:init', () => {
    Alpine.data('CollectionFilters', () => ({
        loading: false,
        loadingMore: false,
        searchQuery: '',
        debounceTimer: null,
        infiniteObserver: null,

        init() {
            const params = new URLSearchParams(window.location.search);
            this.searchQuery = params.get('q') || '';

            const isCollectionPage = window.location.pathname.includes('/collections/');
            if (isCollectionPage && !params.has('sort_by')) {
                params.set('sort_by', 'most-relevant');
                window.history.replaceState({ searchQuery: this.searchQuery }, '', `${window.location.pathname}?${params.toString()}`);
                this.$nextTick(() => this.updateResults(false));
            } else if (isCollectionPage && !params.has('filter.v.availability')) {
                // Shopify renders inaccurate un-faceted variant counts (e.g. 20 / 21) on initial page load
                // Asynchronously fetch accurate faceted availability filter counts and update the sidebars
                this.$nextTick(() => this.refreshAvailabilityCounts());
            }

            window.addEventListener('popstate', () => {
                const newParams = new URLSearchParams(window.location.search);
                this.searchQuery = newParams.get('q') || '';
                this.updateResults(false);
            });

            this.$watch('searchQuery', (value) => {
                if (this.debounceTimer) clearTimeout(this.debounceTimer);
                if (value.trim() === '') {
                    this.updateResults();
                    return;
                }
                this.debounceTimer = setTimeout(() => this.updateResults(), 400);
            });

            // Start infinite scroll
            this.$nextTick(() => this.initInfiniteScroll());
        },

        initInfiniteScroll() {
            // Disconnect any existing observer
            if (this.infiniteObserver) {
                this.infiniteObserver.disconnect();
                this.infiniteObserver = null;
            }

            const sentinel = document.getElementById('InfiniteScrollSentinel');
            if (!sentinel) return;

            this.infiniteObserver = new IntersectionObserver(
                (entries) => {
                    if (entries[0].isIntersecting) {
                        this.appendNextPage();
                    }
                },
                { rootMargin: '200px' }
            );

            this.infiniteObserver.observe(sentinel);
        },

        async appendNextPage() {
            const grid = document.getElementById('ProductGrid');
            if (!grid) return;

            const nextUrl = grid.getAttribute('data-next-url');
            if (!nextUrl || this.loadingMore) return;

            this.loadingMore = true;

            try {
                const res = await fetch(nextUrl);
                if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);

                const htmlText = await res.text();
                const parser = new DOMParser();
                const doc = parser.parseFromString(htmlText, 'text/html');

                const newGrid = doc.getElementById('ProductGrid');
                if (newGrid) {
                    // Append new cards
                    Array.from(newGrid.children).forEach(child => {
                        grid.appendChild(child.cloneNode(true));
                    });
                    // Update next URL (empty string when no more pages)
                    grid.setAttribute('data-next-url', newGrid.getAttribute('data-next-url') || '');
                }

                // Move sentinel below the new cards so it can trigger again
                const sentinel = document.getElementById('InfiniteScrollSentinel');
                if (sentinel) grid.parentNode.appendChild(sentinel);

                // If no more pages, stop observing
                if (!newGrid || !newGrid.getAttribute('data-next-url')) {
                    if (this.infiniteObserver) this.infiniteObserver.disconnect();
                }
            } catch (e) {
                console.error('Infinite scroll fetch failed', e);
            } finally {
                this.loadingMore = false;
            }
        },

        async updateResults(pushState = true) {
            this.loading = true;

            // Close mobile filters if they are open
            if (this.showMobileFilters) {
                this.showMobileFilters = false;
            }

            const isSearchPage = window.location.pathname.startsWith('/search');
            const isCollectionPage = window.location.pathname.includes('/collections/');

            const cleanQuery = this.searchQuery.trim();

            // Use a Map to deduplicate parameters by name (ensures mobile/desktop duplicates don't conflict)
            const paramsMap = new Map();
            let selectedCollectionUrl = null;

            // Handle Query
            if (cleanQuery) {
                paramsMap.set('q', cleanQuery);
            }

            // Handle Type
            if (isSearchPage || (!isCollectionPage && cleanQuery)) {
                paramsMap.set('type', 'product');
            }

            // Handle Filters (Collection Only)
            if (isCollectionPage) {
                const form = document.getElementById('CollectionFiltersForm');
                if (form) {
                    const formData = new FormData(form);
                    // Use entries() to handle multi-value params if needed, 
                    // but for price min/max we want the last one encountered (which will be mobile if it was interacted with)
                    for (const [key, value] of formData.entries()) {
                        if (!value || key === 'q') continue;
                        paramsMap.set(key, value);
                    }
                }
            }

            const ajaxParams = new URLSearchParams();
            paramsMap.forEach((value, key) => ajaxParams.append(key, value));

            const fetchUrl = isSearchPage ? '/search' : (isCollectionPage ? window.location.pathname : '/search');
            const ajaxUrl = `${fetchUrl}${ajaxParams.toString() ? '?' + ajaxParams.toString() : ''}`;

            console.log(`[Search] Fetching results: ${ajaxUrl}`);

            try {
                const res = await fetch(ajaxUrl);
                if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);

                const htmlText = await res.text();
                const parser = new DOMParser();
                const doc = parser.parseFromString(htmlText, 'text/html');

                // Update Grid
                const newGrid = doc.getElementById('ProductGridContainer');
                const currentGrid = document.getElementById('ProductGridContainer');
                if (newGrid && currentGrid) {
                    currentGrid.innerHTML = newGrid.innerHTML;
                }

                // Update Title
                const newTitle = doc.getElementById('CollectionTitle');
                const currentTitle = document.getElementById('CollectionTitle');
                if (newTitle && currentTitle) {
                    currentTitle.innerHTML = newTitle.innerHTML;
                }

                // Update Count
                const newCount = doc.getElementById('ProductCount');
                const currentCount = document.getElementById('ProductCount');
                if (newCount && currentCount) {
                    currentCount.innerHTML = newCount.innerHTML;
                }

                // Update Sidebar (to sync checkbox states and available faceted filters)
                const newSidebar = doc.getElementById('FilterSidebarContent');
                const currentSidebar = document.getElementById('FilterSidebarContent');
                if (newSidebar && currentSidebar) {
                    currentSidebar.innerHTML = newSidebar.innerHTML;
                }

                // Update Mobile Sidebar
                const newMobileSidebar = doc.getElementById('FilterMobileSidebarContent');
                const currentMobileSidebar = document.getElementById('FilterMobileSidebarContent');
                if (newMobileSidebar && currentMobileSidebar) {
                    currentMobileSidebar.innerHTML = newMobileSidebar.innerHTML;
                }

                // Update Mobile Results Count Button
                const newMobileBtn = doc.getElementById('MobileResultsCountButton');
                const currentMobileBtn = document.getElementById('MobileResultsCountButton');
                if (newMobileBtn && currentMobileBtn) {
                    currentMobileBtn.innerHTML = newMobileBtn.innerHTML;
                }

                // Update URL
                if (pushState) {
                    window.history.pushState({ searchQuery: cleanQuery }, '', ajaxUrl);
                }

                // Re-init infinite scroll after filter/sort update
                this.$nextTick(() => this.initInfiniteScroll());

            } catch (e) {
                console.error('Search update failed', e);
            } finally {
                this.loading = false;
            }
        },

        async refreshAvailabilityCounts() {
            try {
                const params = new URLSearchParams(window.location.search);
                params.set('filter.v.availability', '1');
                const fetchUrl = `${window.location.pathname}?${params.toString()}`;

                const res = await fetch(fetchUrl);
                if (!res.ok) return;

                const htmlText = await res.text();
                const parser = new DOMParser();
                const doc = parser.parseFromString(htmlText, 'text/html');

                const updateCountSpans = (sourceContainer, targetContainer) => {
                    if (!sourceContainer || !targetContainer) return;
                    const srcInputs = sourceContainer.querySelectorAll('input[name="filter.v.availability"]');
                    const targetInputs = targetContainer.querySelectorAll('input[name="filter.v.availability"]');

                    targetInputs.forEach((input) => {
                        const matchingSrc = Array.from(srcInputs).find(i => i.value === input.value);
                        if (matchingSrc) {
                            const srcCountSpan = matchingSrc.closest('label')?.querySelector('span:last-child');
                            const targetCountSpan = input.closest('label')?.querySelector('span:last-child');
                            if (srcCountSpan && targetCountSpan) {
                                targetCountSpan.textContent = srcCountSpan.textContent;
                            }
                        }
                    });
                };

                updateCountSpans(doc.getElementById('FilterSidebarContent'), document.getElementById('FilterSidebarContent'));
                updateCountSpans(doc.getElementById('FilterMobileSidebarContent'), document.getElementById('FilterMobileSidebarContent'));
            } catch (e) {
                console.error('Failed to refresh availability counts', e);
            }
        },

        clearFilters() {
            window.location.href = window.location.pathname;
        }
    }));
});
